export default class ApiClient {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }

    async fetchData() {
        try {
            const response = await fetch(this.apiUrl);

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();

            return data;
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
            throw error;
        }
    }
}
